import { MatPaginatorIntl } from '@angular/material/paginator';
import { Injectable } from '@angular/core';

@Injectable()
export class CustomMatPaginatorIntl extends MatPaginatorIntl {
  constructor() {
    super();

    this.getAndInitTranslations();
  }

  getAndInitTranslations() {
    this.itemsPerPageLabel = 'Einträge pro Seite';
    this.nextPageLabel = 'Weiter';
    this.previousPageLabel = 'Zurück';
  }

  getRangeLabel = (page: number, pageSize: number, length: number) => {
    const customRangeLabel = 'angezeigte Einträge:';

    if (length === 0 || pageSize === 0) {
      return `${customRangeLabel} 0 von ${length}`;
    }
    length = Math.max(length, 0);

    const startIndex = page * pageSize;
    const endIndex = startIndex < length ? Math.min(startIndex + pageSize, length) : startIndex + pageSize;
    return `${customRangeLabel} ${startIndex + 1} - ${endIndex} von ${length}`;
  };
}
